<h3>If you have already been granted access and are logged into multiple devices, 
    please navigate back to <a routerLink="/">the homepage</a> .  
    If you aren't sure, please contact <a href="mailto:devsupport@transnetyx.com">devsupport&#64;transnetyx.com</a> 
    to get access.</h3>